$(document).ready(function () {
  //Modal Elements
  var mqDialog = document.createElement("div");
  var mqContent = document.createElement("div");
  var mqTabs = document.createElement("div");
  var mqTabsBody = document.createElement("div");
  var mqFieldElement = document.createElement("span");
  var mqFooter = document.createElement("div");
  var mqGetValueBtn = document.createElement("button");
  var mqCancelBtn = document.createElement("button");

  mqGetValueBtn.innerHTML = "Ok";
  mqCancelBtn.innerHTML = "Cancel";

  //Element Classes
  mqDialog.className = "mqEditor-wrapper";
  mqContent.className = "mqEditor-content";
  mqGetValueBtn.className = "mqEditor-btn mqEditor-getValue";
  mqCancelBtn.className = "mqEditor-btn";
  mqTabs.className = "mqEditor-tabs";
  mqTabsBody.className = "mqEditor-tabs-wrapper";
  mqFooter.className = "mqEditor-footer";

  //Main Wrapper Id
  mqDialog.id = "mqDialog";

  //Setting InnerHTML
  mqTabs.innerHTML =
    '<div class="tabs-button-wrapper"><a class="tabs-button tab-1 active" value="tab-1"> <span class="tab-inside"></span></a><a class="tabs-button tab-2" value="tab-2"> <span class="tab-inside"></span></a><a class="tabs-button tab-3" value="tab-3"> <span class="tab-inside"></span></a><a class="tabs-button tab-4" value="tab-4"> <span class="tab-inside"></span></a><a class="tabs-button tab-5" value="tab-5"> <span class="tab-inside"></span></a><a class="tabs-button tab-6" value="tab-6"> <span class="tab-inside"></span></a><a class="tabs-button tab-7" value="tab-7"> <span class="tab-inside"></span></a><div class="tabs-divider"></div></div>';

  mqTabsBody.innerHTML =
    '<div class="mqEditor-row-wrapper tab-1 active"><div class="mqEditor-row"><a class="mq-insert-buttons mq-fraction" title="Insert Fraction" value="mqfraction"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-squareroot" title="Insert Square Root" value="mqsquareroot"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-superscript" title="Insert Superscript" value="mqsuperscript"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-parenthese" title="Insert Parenthese" value="mqparenthese"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-sqbrackets" title="Insert Square Brackets" value="mqsqbrackets"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-plus" title="Insert Plus Sign" value="mqplus"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-multiply" title="Insert Multiply Sign" value="mqmultiply"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-minus" title="Insert Minus Sign" value="mqminus"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-gteq" title="Insert Greater Than or Equal To Sign" value="mqgteq"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-lteq" title="Insert Less Than or Equal To Sign" value="mqlteq"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-subset" title="Insert Subset Sign" value="mqsubset"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-pi" title="Insert Pi Sign" value="mqpi"><span class="span-inside"></span></a></div><div class="mqEditor-row"><a class="mq-insert-buttons mq-bevelled" title="Insert  Bevelled Fraction" value="mqbevelled"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-root" title="Insert Root" value="mqroot"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-subscript" title="Insert Subscript" value="mqsubscript"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-vbars" title="Insert Vertical Bars" value="mqvbars"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-curlyBrackets" title="Insert Curly Brackets" value="mqcurlyBrackets"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-forwSlash" title="Insert Forward Slash" value="mqforwSlash"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-plusminus" title="Insert Plus-Minus Sign" value="mqplusminus"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-division" title="Insert Division Sign" value="mqdivision"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-union" title="Insert Uninon Sign" value="mqunion"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-intersect" title="Insert Intersect Sign" value="mqintersect"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-elementOf" title="Insert Element Sign" value="mqelementOf"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-infinity" title="Insert Infinity Sign" value="mqinfinity"><span class="span-inside"></span></a></div></div><div class="mqEditor-row-wrapper tab-2"><div class="mqEditor-row"><a class="mq-insert-buttons mq-plus" title="Insert Plus Sign" value="mqplus"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-multiply" title="Insert Multiply Sign" value="mqmultiply"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-middleDot" title="Insert Middle Dot Sign" value="mqmiddleDot"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-minus" title="Insert Minus Sign" value="mqminus"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-plusminus" title="Insert Plus-Minus Sign" value="mqplusminus"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-division" title="Insert Division Sign" value="mqdivision"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-forwSlash" title="Insert Forward Slash" value="mqforwSlash"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-asterisk" title="Insert Asterisk Sign" value="mqasterisk"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-equalsTo" title="Insert Equals To Sign" value="mqequalsTo"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-equivalent" title="Insert Equivalent To Sign" value="mqequivalent"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-tilde" title="Insert Tilde Sign" value="mqtilde"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-almostEquals" title="Insert Almost Equals To Sign" value="mqalmostEquals"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-asymptotically" title="Insert Asymptotically Equals To Sign" value="mqasymptotically"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-approx" title="Insert Approx Equals To Sign" value="mqapprox"><span class="span-inside"></span></a></div><div class="mqEditor-row"><a class="mq-insert-buttons mq-greaterThan" title="Insert Greater Than Sign" value="mqgreaterThan"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-lessThan" title="Insert Less Than Sign" value="mqlessThan"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-gteq" title="Insert Greater Than or Equal To Sign" value="mqgteq"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-lteq" title="Insert Less Than or Equal To Sign" value="mqlteq"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-pi" title="Insert Pi Sign" value="mqpi"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-infinity" title="Insert Infinity Sign" value="mqinfinity"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-increment" title="Insert Increment Sign" value="mqincrement"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-nabla" title="Insert Nabla Sign" value="mqnabla"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-elementOf" title="Insert Element Sign" value="mqelementOf"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-membersOf" title="Insert Contains Member Of Sign" value="mqmembersOf"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-subset" title="Insert Subset Sign" value="mqsubset"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-superset" title="Insert Superset Sign" value="mqsuperset"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-union" title="Insert Uninon Sign" value="mqunion"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-intersect" title="Insert Intersect Sign" value="mqintersect"><span class="span-inside"></span></a></div><div class="mqEditor-row"><a class="mq-insert-buttons mq-square" title="Insert Square Sign" value="mqsquare"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-triangle" title="Insert Triangle Sign" value="mqtriangle"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-circle" title="Insert Circle Sign" value="mqcircle"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-rectangle" title="Insert Rectangle Sign" value="mqrectangle"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-rhoumbus" title="Insert Rhoumbus Sign" value="mqrhoumbus"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-angle" title="Insert Angle Sign" value="mqangle"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-parallel" title="Insert Parallel Sign" value="mqparallel"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-notParallel" title="Insert Not Parallel Sign" value="mqnotParallel"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-perpendi" title="Insert Perpendicular Sign" value="mqperpendi"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-emptySet" title="Insert Empty Set Sign" value="mqemptySet"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-partial" title="Insert Partial Differential Sign" value="mqpartial"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-degree" title="Insert Degree Sign" value="mqdegree"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-therefore" title="Insert Therefore Sign" value="mqtherefore"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-because" title="Insert Because Sign" value="mqbecause"><span class="span-inside"></span></a></div></div><div class="mqEditor-row-wrapper tab-3"><div class="mqEditor-row"><a class="mq-insert-buttons mq-leftArrow" title="Insert Leftwards Arrow Sign" value="mqleftArrow"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-rightArrow" title="Insert Rightwards Arrow Sign" value="mqrightArrow"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-leftDoubleArrow" title="Insert Leftwards Double Arrow" value="mqleftDoubleArrow"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-rightDoubleArrow" title="Insert Rightwards Double Arrow" value="mqrightDoubleArrow"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-leftRightDoubleArrow" title="Insert Left Right Double Arrow" value="mqleftRightDoubleArrow"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-uparrow" title="Insert Upwards Arrow" value="mquparrow"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-downarrow" title="Insert Downwards Arrow" value="mqdownarrow"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-uparrowDouble" title="Insert Upwards Double Arrow" value="mquparrowDouble"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-downarrowDouble" title="Insert Downwards Double Arrow" value="mqdownarrowDouble"><span class="span-inside"></span></a></div><div class="mqEditor-row"><a class="mq-insert-buttons mq-leftRightArrow" title="Insert Left Right Arrow Sign" value="mqleftRightArrow"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-rightArrowWithBar" title="Insert Right Arrow With Bar" value="mqrightArrowWithBar"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-arrowAccent" title="Insert Arrow Accent" value="mqarrowAccent"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-leftArrowUnderscript" title="Insert Left Arrow With Underscript" value="mqleftArrowUnderscript"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-overlinePlan" title="Insert Bar Accent" value="mqoverlinePlan"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-vEllipsis" title="Insert Vertical Ellipsis" value="mqvEllipsis"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-dEllipsis" title="Insert Down Right Diagonal Ellipsis" value="mqdEllipsis"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-mEllipsis" title="Insert Midline Horizontal Ellipsis" value="mqmEllipsis"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-hEllipsis" title="Insert Horizontal Ellipsis" value="mqhEllipsis"><span class="span-inside"></span></a></div></div><div class="mqEditor-row-wrapper tab-4"><div class="mqEditor-row"><a class="mq-insert-buttons mq-alpha" title="Insert Alpha Sign" value="mqalpha"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-beta" title="Insert Beta Sign" value="mqbeta"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-gamma" title="Insert Gamma Sign" value="mqgamma"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-delta" title="Insert Delta Sign" value="mqdelta"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-epsilon" title="Insert Epsilon Sign" value="mqepsilon"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-zeta" title="Insert Zeta Sign" value="mqzeta"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-eta" title="Insert Eta Sign" value="mqeta"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-theta" title="Insert Theta Sign" value="mqtheta"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-vartheta" title="Insert Theta Sign" value="mqvartheta"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-iota" title="Insert Iota Sign" value="mqiota"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-kappa" title="Insert Kappa Sign" value="mqkappa"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-lambda" title="Insert Lambda Sign" value="mqlambda"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-mu" title="Insert Mu Sign" value="mqmu"><span class="span-inside"></span></a></div><div class="mqEditor-row"><a class="mq-insert-buttons mq-nu" title="Insert Nu Sign" value="mqnu"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-xi" title="Insert Xi Sign" value="mqxi"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-omicron" title="Insert Omicron Sign" value="mqomicron"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-pi" title="Insert Pi Sign" value="mqpi"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-rho" title="Insert Rho Sign" value="mqrho"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-finalSigma" title="Insert Final Sigma Sign" value="mqfinalSigma"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-sigma" title="Insert Sigma Sign" value="mqsigma"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-tau" title="Insert Tau Sign" value="mqtau"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-upsilon" title="Insert Upsilon Sign" value="mqupsilon"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-phi" title="Insert Phi Sign" value="mqphi"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-chi" title="Insert Chi Sign" value="mqchi"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-psi" title="Insert Psi Sign" value="mqpsi"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-omega" title="Insert Omega Sign" value="mqomega"><span class="span-inside"></span></a></div></div><div class="mqEditor-row-wrapper tab-5"><div class="mqEditor-row"><a class="mq-insert-buttons mq-3row-col" title="Insert 3 Rows Coloumn" value="mq3rowcol"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-table" title="Insert Table" value="mqtable"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-2row-col-bracket" title="Insert 2 Rows Coloumn With Brackets" value="mq2rowcolbracket"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-2row-col-parent" title="Insert 2 Rows Coloumn With Parenthesis" value="mq2rowcolparent"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-matrix-vbar" title="Insert Matrix With Vertical Bars" value="mqmatrixvbar"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-matrix" title="Insert Matrix" value="mqmatrix"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-matrix-parent" title="Insert Matrix" value="mqmatrixparent"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-vEllipsis" title="Insert Vertical Ellipsis" value="mqvEllipsis"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-dEllipsis" title="Insert Down Right Diagonal Ellipsis" value="mqdEllipsis"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-mEllipsis" title="Insert Midline Horizontal Ellipsis" value="mqmEllipsis"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-hEllipsis" title="Insert Horizontal Ellipsis" value="mqhEllipsis"><span class="span-inside"></span></a></div></div><div class="mqEditor-row-wrapper tab-6"><div class="mqEditor-row"><a class="mq-insert-buttons mq-fraction" title="Insert Fraction" value="mqfraction"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-bevelled" title="Insert  Bevelled Fraction" value="mqbevelled"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-squareroot" title="Insert Square Root" value="mqsquareroot"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-root" title="Insert Root" value="mqroot"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-superscript" title="Insert Superscript" value="mqsuperscript"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-subscript" title="Insert Subscript" value="mqsubscript"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-super-subscript" title="Insert Superscript and Subscript" value="mqsupersubscript"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-left-superscript" title="Insert Left Supercript" value="mqleftsuperscript"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-left-subscript" title="Insert Left Subscript" value="mqleftsubscript"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-left-super-subscript" title="Insert Left Superscript and Subscript" value="mqleftsupersubscript"><span class="span-inside"></span></a></div></div><div class="mqEditor-row-wrapper tab-7"><div class="mqEditor-row"><a class="mq-insert-buttons mq-summation" title="Insert Summation Sign" value="mqsummation"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-product" title="Insert Product Sign" value="mqproduct"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-union" title="Insert Uninon Sign" value="mqunion"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-intersect" title="Insert Intersect Sign" value="mqintersect"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-integral" title="Insert Integral Sign" value="mqintegral"><span class="span-inside"></span></a><a class="mq-insert-buttons mq-c-integral" title="Insert Contour Integral Sign" value="mqcintegral"><span class="span-inside"></span></a></div></div>';

  mqFooter.appendChild(mqGetValueBtn);
  mqFooter.appendChild(mqCancelBtn);

  //Elements structuring
  mqContent.appendChild(mqTabs);
  mqContent.appendChild(mqTabsBody);
  mqContent.appendChild(mqFieldElement);
  mqContent.appendChild(mqFooter);
  mqDialog.appendChild(mqContent);

  document.body.appendChild(mqDialog);

  window.somethingSelected = false;

  var mqButtonsActions = {
    mqparenthese: function () {
      mqMathField.write("\\left(\\right)");
      mqMathField.focus();
    },
    mqsqbrackets: function () {
      mqMathField.write("\\left[\\right]");
      mqMathField.focus();
    },
    mqvbars: function () {
      mqMathField.write("\\left|\\right|");
      mqMathField.focus();
    },
    mqcurlyBrackets: function () {
      mqMathField.write("\\left\\{\\right\\}");
      mqMathField.focus();
    },
    mqplus: function () {
      mqMathField.write("+");
      mqMathField.focus();
    },
    mqmultiply: function () {
      mqMathField.cmd("\\times");
      mqMathField.focus();
    },
    mqmiddleDot: function () {
      mqMathField.cmd("\\cdot");
      mqMathField.focus();
    },
    mqminus: function () {
      mqMathField.write("-");
      mqMathField.focus();
    },
    mqplusminus: function () {
      mqMathField.cmd("\\pm");
      mqMathField.focus();
    },
    mqdivision: function () {
      mqMathField.cmd("\\div");
      mqMathField.focus();
    },
    mqforwSlash: function () {
      mqMathField.write(" / ");
      mqMathField.focus();
    },
    mqasterisk: function () {
      mqMathField.cmd("\\ast");
      mqMathField.focus();
    },
    mqequalsTo: function () {
      mqMathField.cmd("=");
      mqMathField.focus();
    },
    mqequivalent: function () {
      mqMathField.cmd("\\equiv");
      mqMathField.focus();
    },
    mqtilde: function () {
      mqMathField.cmd("\\sim");
      mqMathField.focus();
    },
    mqalmostEquals: function () {
      mqMathField.cmd("\\approx");
      mqMathField.focus();
    },
    mqasymptotically: function () {
      mqMathField.cmd("\\simeq");
      mqMathField.focus();
    },
    mqapprox: function () {
      mqMathField.cmd("\\cong");
      mqMathField.focus();
    },
    mqgreaterThan: function () {
      mqMathField.cmd(">");
      mqMathField.focus();
    },
    mqlessThan: function () {
      mqMathField.cmd("<");
      mqMathField.focus();
    },
    mqgteq: function () {
      mqMathField.cmd("\\geq");
      mqMathField.focus();
    },
    mqlteq: function () {
      mqMathField.cmd("\\leq");
      mqMathField.focus();
    },
    mqsubset: function () {
      mqMathField.cmd("\\sub");
      mqMathField.focus();
    },
    mqinfinity: function () {
      mqMathField.cmd("\\infty");
      mqMathField.focus();
    },
    mqincrement: function () {
      mqMathField.cmd("\\triangle");
      mqMathField.focus();
    },
    mqnabla: function () {
      mqMathField.cmd("\\nabla");
      mqMathField.focus();
    },
    mqelementOf: function () {
      mqMathField.cmd("\\in");
      mqMathField.focus();
    },
    mqmembersOf: function () {
      mqMathField.cmd("\\ni");
      mqMathField.focus();
    },
    mqsuperset: function () {
      mqMathField.cmd("\\supset");
      mqMathField.focus();
    },
    mqsquare: function () {
      mqMathField.cmd("\\square");
      mqMathField.focus();
    },
    mqtriangle: function () {
      mqMathField.cmd("\\bigtriangleup");
      mqMathField.focus();
    },
    mqcircle: function () {
      mqMathField.cmd("\\bigcirc");
      mqMathField.focus();
    },
    mqrectangle: function () {
      mqMathField.cmd("▭");
      mqMathField.focus();
    },
    mqrhoumbus: function () {
      mqMathField.cmd("▱");
      mqMathField.focus();
    },
    mqangle: function () {
      mqMathField.cmd("\\angle");
      mqMathField.focus();
    },
    mqparallel: function () {
      mqMathField.cmd("\\parallel");
      mqMathField.focus();
    },
    mqnotParallel: function () {
      mqMathField.cmd("\\nparallel");
      mqMathField.focus();
    },
    mqperpendi: function () {
      mqMathField.cmd("\\perp");
      mqMathField.focus();
    },
    mqemptySet: function () {
      mqMathField.write("\\varnothing");
      mqMathField.focus();
    },
    mqpartial: function () {
      mqMathField.write("\\partial");
      mqMathField.focus();
    },
    mqdegree: function () {
      mqMathField.write("^\\circ");
      mqMathField.focus();
    },
    mqtherefore: function () {
      mqMathField.write("\\therefore");
      mqMathField.focus();
    },
    mqbecause: function () {
      mqMathField.write("\\because");
      mqMathField.focus();
    },
    mqleftArrow: function () {
      mqMathField.cmd("\\leftarrow");
      mqMathField.focus();
    },
    mqrightArrow: function () {
      mqMathField.cmd("\\rightarrow");
      mqMathField.focus();
    },
    mqleftDoubleArrow: function () {
      mqMathField.cmd("\\Leftarrow");
      mqMathField.focus();
    },
    mqrightDoubleArrow: function () {
      mqMathField.cmd("\\Rightarrow");
      mqMathField.focus();
    },
    mqleftRightDoubleArrow: function () {
      mqMathField.cmd("\\Leftrightarrow");
      mqMathField.focus();
    },
    mquparrow: function () {
      mqMathField.cmd("\\uparrow");
      mqMathField.focus();
    },
    mqdownarrow: function () {
      mqMathField.cmd("\\downarrow");
      mqMathField.focus();
    },
    mquparrowDouble: function () {
      mqMathField.cmd("\\Uparrow");
      mqMathField.focus();
    },
    mqdownarrowDouble: function () {
      mqMathField.cmd("\\Downarrow");
      mqMathField.focus();
    },
    mqleftRightArrow: function () {
      mqMathField.cmd("\\leftrightarrow");
      mqMathField.focus();
    },
    mqrightArrowWithBar: function () {
      mqMathField.cmd("\\mapsto");
      mqMathField.focus();
    },
    mqarrowAccent: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      if (somethingSelected === false) {
        mqMathField.cmd("\\vec");
        mqMathField.focus();
      } else {
        mqMathField.cmd("\\vec");
      }
    },
    mqleftArrowUnderscript: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      if (somethingSelected === false) {
        mqMathField.cmd("\\overleftarrow");
        mqMathField.focus();
      } else {
        mqMathField.cmd("\\overleftarrow");
      }
    },
    mqoverlinePlan: function () {
      mqMathField.cmd("\\overline");
      mqMathField.focus();
    },
    mqvEllipsis: function () {
      mqMathField.cmd("\\vdots");
      mqMathField.focus();
    },
    mqdEllipsis: function () {
      mqMathField.cmd("\\ddots");
      mqMathField.focus();
    },
    mqmEllipsis: function () {
      mqMathField.cmd("\\cdots");
      mqMathField.focus();
    },
    mqhEllipsis: function () {
      mqMathField.cmd("\\dots");
      mqMathField.focus();
    },
    mqalpha: function () {
      mqMathField.cmd("\\alpha");
      mqMathField.focus();
    },
    mqbeta: function () {
      mqMathField.cmd("\\beta");
      mqMathField.focus();
    },
    mqgamma: function () {
      mqMathField.cmd("\\gamma");
      mqMathField.focus();
    },
    mqdelta: function () {
      mqMathField.cmd("\\delta");
      mqMathField.focus();
    },
    mqepsilon: function () {
      mqMathField.cmd("\\varepsilon");
      mqMathField.focus();
    },
    mqzeta: function () {
      mqMathField.cmd("\\zeta");
      mqMathField.focus();
    },
    mqeta: function () {
      mqMathField.cmd("\\eta");
      mqMathField.focus();
    },
    mqtheta: function () {
      mqMathField.cmd("\\theta");
      mqMathField.focus();
    },
    mqvartheta: function () {
      mqMathField.cmd("\\vartheta");
      mqMathField.focus();
    },
    mqiota: function () {
      mqMathField.cmd("\\iota");
      mqMathField.focus();
    },
    mqkappa: function () {
      mqMathField.cmd("\\kappa");
      mqMathField.focus();
    },
    mqlambda: function () {
      mqMathField.cmd("\\lambda");
      mqMathField.focus();
    },
    mqmu: function () {
      mqMathField.cmd("\\mu");
      mqMathField.focus();
    },
    mqnu: function () {
      mqMathField.cmd("\\nu");
      mqMathField.focus();
    },
    mqxi: function () {
      mqMathField.cmd("\\xi");
      mqMathField.focus();
    },
    mqomicron: function () {
      mqMathField.cmd("o");
      mqMathField.focus();
    },
    mqpi: function () {
      mqMathField.write("\\mathrm\\pi");
      mqMathField.focus();
    },
    mqrho: function () {
      mqMathField.write("\\rho");
      mqMathField.focus();
    },
    mqfinalSigma: function () {
      mqMathField.write("\\varsigma");
      mqMathField.focus();
    },
    mqsigma: function () {
      mqMathField.write("\\Sigma");
      mqMathField.focus();
    },
    mqtau: function () {
      mqMathField.write("\\tau");
      mqMathField.focus();
    },
    mqupsilon: function () {
      mqMathField.write("\\upsilon");
      mqMathField.focus();
    },
    mqphi: function () {
      mqMathField.write("\\phi");
      mqMathField.focus();
    },
    mqchi: function () {
      mqMathField.write("\\chi");
      mqMathField.focus();
    },
    mqpsi: function () {
      mqMathField.write("\\psi");
      mqMathField.focus();
    },
    mqomega: function () {
      mqMathField.write("\\Omega");
      mqMathField.focus();
    },
    mq3rowcol: function () {
      mqMathField.write("\\begin{matrix}\\\\\\\\\\end{matrix}");
      mqMathField.focus();
    },
    mqtable: function () {
      mqMathField.write("\\begin{matrix}&&\\\\&&\\\\&&\\end{matrix}");
      mqMathField.focus();
    },
    mq2rowcolbracket: function () {
      mqMathField.write("\\begin{bmatrix}\\\\\\end{bmatrix}");
      mqMathField.focus();
    },
    mq2rowcolparent: function () {
      mqMathField.write("\\begin{pmatrix}\\\\\\end{pmatrix}");
      mqMathField.focus();
    },
    mqmatrixvbar: function () {
      mqMathField.write("\\begin{vmatrix}&\\\\&\\end{vmatrix}");
      mqMathField.focus();
    },
    mqmatrix: function () {
      mqMathField.write("\\begin{bmatrix}&\\\\&\\end{bmatrix}");
      mqMathField.focus();
    },
    mqmatrixparent: function () {
      mqMathField.write("\\begin{pmatrix}&\\\\&\\end{pmatrix}");
      mqMathField.focus();
    },
    mqvEllipsis: function () {
      mqMathField.cmd("\\vdots");
      mqMathField.focus();
    },
    mqdEllipsis: function () {
      mqMathField.cmd("\\ddots");
      mqMathField.focus();
    },
    mqmEllipsis: function () {
      mqMathField.cmd("\\cdots");
      mqMathField.focus();
    },
    mqhEllipsis: function () {
      mqMathField.cmd("\\dots");
      mqMathField.focus();
    },
    mqfraction: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      if (somethingSelected === false) {
        mqMathField.write("\\frac{}{}");
        mqMathField.keystroke("Left");
        mqMathField.keystroke("Left");
        mqMathField.focus();
      } else {
        mqMathField.cmd("\\frac");
      }
    },
    mqbevelled: function () {
      mqMathField.write("^{}/_{}");
      mqMathField.focus();
    },
    mqsquareroot: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }

      console.log("somethingSelected", somethingSelected);

      if (somethingSelected === false) {
        mqMathField.cmd("\\sqrt");
        mqMathField.focus();
      } else {
        console.log("cmding here");
        mqMathField.focus();
        mqMathField.cmd("\\sqrt");
      }
    },
    mqroot: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      mqMathField.write("\\sqrt[{}]{}");
      mqMathField.keystroke("Left");
      mqMathField.focus();
    },
    mqsuperscript: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      if (somethingSelected === false) {
        mqMathField.write("^{}");
        mqMathField.keystroke("Left");
        mqMathField.focus();
      } else {
        mqMathField.cmd("^");
      }
    },
    mqsubscript: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      if (somethingSelected === false) {
        mqMathField.write("_{}");
        mqMathField.keystroke("Left");
        mqMathField.focus();
      } else {
        mqMathField.cmd("_");
      }
    },
    mqsupersubscript: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      mqMathField.write("_{}^{}");
      mqMathField.keystroke("Left");
      mqMathField.focus();
    },
    mqleftsuperscript: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      mqMathField.keystroke("Left");
      mqMathField.write("{}^{}{}");
      mqMathField.focus();
    },
    mqleftsubscript: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      mqMathField.keystroke("Left");
      mqMathField.write("{}_{}{}");
      mqMathField.focus();
    },
    mqleftsupersubscript: function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.stop();
      }
      mqMathField.write("{}_{}^{}{}");
      mqMathField.focus();
    },
    mqsummation: function () {
      mqMathField.cmd("\\sum");
      mqMathField.focus();
    },
    mqproduct: function () {
      mqMathField.cmd("\\prod");
      mqMathField.focus();
    },
    mqunion: function () {
      mqMathField.cmd("\\cup");
      mqMathField.focus();
    },
    mqintersect: function () {
      mqMathField.cmd("\\cap");
      mqMathField.focus();
    },
    mqintegral: function () {
      mqMathField.write("\\integral");
      mqMathField.focus();
    },
    mqcintegral: function () {
      mqMathField.write("\\oint");
      mqMathField.focus();
    },
  };

  var currentCb = null;
  mqFieldElement.setAttribute("id", "mqTextArea");

  mqMathField = MQ.MathField(mqFieldElement, {
    handlers: {
      enter: function () {
        getLatex();
      },
    },
  });

  var getLatex = () => {
    var enteredMath = mqMathField.latex();
    if (currentCb !== null) {
      if (enteredMath.length) {
        currentCb(enteredMath);
        currentCb = null; //Setting the currentCb to null
        mqDialog.style.display = "none";
        mqMathField.latex("");
      } else {
        closeAndClearMqField();
      }
    } else {
      throw new Error("callback not defined");
    }
  };

  mqGetValueBtn.onclick = function () {
    getLatex();
  };

  function closeAndClearMqField() {
    mqDialog.style.display = "none";
    mqMathField.latex("");
  }

  showUI = (cb, equation, pamojamaths) => {
    if(typeof pamojamaths === "string"){
      pamojamaths = pamojamaths === "false" ? false : true; 
    }

    if (!pamojamaths) {
      mqDialog.style.display = "block";

      //Setting the current selected equation
      if (equation !== undefined && equation !== null) {
        mqMathField.latex(equation);
      }
      mqMathField.focus();
      currentCb = cb;
    }

    $(document).bind("keydown", function (event) {
      if (event.key === "Escape" && mqDialog.style.display === "block") {
        closeAndClearMqField();
      } else if (mqDialog.style.display !== "block") {
        $(document).unbind(event);
      }
    });
  };
   
  // $("#mqTextArea").mouseout(function () {
  //   console.log("mouseout");
  //   if ($(".mq-selection").length != 0) {
  //     somethingSelected = true;
  //   } else {
  //     somethingSelected = false;
  //   }
  // });

  // To prevent focus
  // $(document).mousedown(function (event) {
  //   event.preventDefault();
  // });

  window.onclick = function (evt) {
    if (evt.target == mqDialog) {
      closeAndClearMqField();
    }
  };

  mqCancelBtn.onclick = function (event) {
    closeAndClearMqField();
  };

  $(".tabs-button").on("click", function (e) {
    var selectedTab = "." + e.currentTarget.getAttribute("value");
    $(".tabs-button").removeClass("active");
    $(".mqEditor-row-wrapper").removeClass("active");
    $(selectedTab).addClass("active");
  });

  $(".mq-insert-buttons").on("click", function (e) {
    var selectedTab = e.currentTarget.getAttribute("value");
    mqButtonsActions[selectedTab](e);
  });
});
